import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-down-right', 'ChevronsDownRight', [["path",{"d":"M13 5v8h-8","key":"svg-0"}],["path",{"d":"M17 9v8h-8","key":"svg-1"}]]);